import React, { useState } from 'react';
import axios from 'axios';
import { setUserSession } from '../../Utils/common';
import { Form, Input, Button, Row, Col, Card } from 'antd';
import config from '../../config'

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

const Login = (props) => {

  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [error, setError] = useState(null);

  const onFinish = (values) => {
    console.log('Success:', values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

    // handle button click of login form
    const handleLogin = () => {
      setLoading(true);
      axios.post(config.api_url + '/api/auth/login',
       { username: form.getFieldValue("username"), password:  form.getFieldValue("password")}
      ).then(response => {
        setLoading(false);
        setUserSession(response.data.token, response.data.user);
        props.history.push('/');
      }).catch(error => {
        setLoading(false);
        setError("Usuario o Contrasena incorrectos")
      });
    }


  return (
    <Row type="flex" justify="center" align="middle" style={{minHeight: '100vh'}}>
      <Col>
       <Card title={error} headStyle={{ color: 'red', textAlign: 'center'}}>
          <Form
            {...layout}
            form={form}
            name="login"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
          <Form.Item
            label="Usuario"
            name="username"
            rules={[
              {
                required: true,
                message: 'Por favor, ingrese su usuario',
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Contrasena"
            name="password"
            rules={[
              {
                required: true,
                message: 'Por favor, ingrese su contrasena',
              },
            ]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item {...tailLayout}>
            <Button type="primary" onClick={handleLogin} htmlType="submit" loading={loading}>
              Ingresar
            </Button>
          </Form.Item>
        </Form>
        </Card>
      </Col>
      </Row>
  );
};

// ReactDOM.render(<Demo />, mountNode);

function Login2(props) {
  const [loading, setLoading] = useState(false);
  const username = useFormInput('');
  const password = useFormInput('');
  const [error, setError] = useState(null);

  // handle button click of login form
  const handleLogin = () => {
    setError(null);
    setLoading(true);
    axios.post(config.api_url + '/api/auth/login', { username: username.value, password: password.value }).then(response => {
      setLoading(false);
      setUserSession(response.data.token, response.data.user);
      props.history.push('/dashboard');
    }).catch(error => {
      setLoading(false);
      if (error.response.status === 401) setError(error.response.data.message);
      else setError("Something went wrong. Please try again later.");
    });
  }

  return (
    <div>
      Login<br /><br />
      <div>
        Username<br />
        <input type="text" {...username} autoComplete="new-password" />
      </div>
      <div style={{ marginTop: 10 }}>
        Password<br />
        <input type="password" {...password} autoComplete="new-password" />
      </div>
      {error && <><small style={{ color: 'red' }}>{error}</small><br /></>}<br />
      <input type="button" value={loading ? 'Loading...' : 'Login'} onClick={handleLogin} disabled={loading} /><br />
    </div>
  );
}

const useFormInput = initialValue => {
  const [value, setValue] = useState(initialValue);

  const handleChange = e => {
    setValue(e.target.value);
  }
  return {
    value,
    onChange: handleChange
  }
}

export default Login;
